import { Injectable } from '@angular/core';
import { Events} from 'ionic-angular';
import { AngularFireAuth } from '@angular/fire/auth';
import { BehaviorSubject, Observable,Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { DataProvider } from '../data/data';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
import { environment } from '../../environments/environment';
const CLOUD_FUNC_URL = environment.cloudUrl;
@Injectable()
export class AuthProvider {
  
  
  jobsCollection: AngularFirestoreCollection<any>;
  jobs$:Observable<any[]>;
  jobs:any;
  rolesCollection: AngularFirestoreCollection<any>;
  roles$:Observable<any[]>;
  roles:any;

  private showLogoutBtnSubject = new BehaviorSubject<boolean>(false);
  isShowLogoutBtn$ = this.showLogoutBtnSubject.asObservable();

  constructor(public events: Events, private fireAuth: AngularFireAuth,public data:DataProvider,private storage: Storage,private afs: AngularFirestore,private http: HttpClient) {
    console.log('Hello AuthProvider Provider');
  }

  intializeSubscriptions(){

    this.jobsCollection = this.afs.collection('jobs');
    this.jobs$ = this.jobsCollection.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data();
            return data;
         })));
    
     this.jobs$.subscribe( (jobs:any) => {  

           this.jobs = {};

           jobs.forEach((job) => {
             this.jobs[job.id] = job.active;
           });
           this.storage.set('jobs',this.jobs);
           console.log(this.jobs);
     });


    this.rolesCollection = this.afs.collection('roles');
    this.roles$ = this.rolesCollection.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return { id, ...data };
    })));
    
     this.roles$.subscribe( (roles:any) => {  

           this.roles = {};
            roles.forEach((role) => {
             const id = role.id;
             delete role['id'];
             delete role['active'];
             if(role.jobs){
               this.roles[id] = role.jobs;
             }
             
           
           });
           this.storage.set('approles',this.roles);

           console.log(this.roles);
     });


  	 this.fireAuth.authState.subscribe(async (user: any) => {
      
      console.log(user);



	    if(user && user.uid){ 
          const uid = await this.storage.get('uid');
          const roles = await this.storage.get('roles');
          const email = await this.storage.get('email');

          const userDoc:any = await this.data.getDoc('users/'+ user.uid);

          if(userDoc.active){
          if(uid && roles && email){
           
               this.events.publish('user:authenticated');

              if(userDoc && userDoc.email){
                 await this.storage.set('email', userDoc.email);
              }

              if(userDoc && userDoc.name){
                await this.storage.set('uname', userDoc.name);
             }
             
              if(userDoc && userDoc.roles){
                 await this.storage.set('roles', userDoc.roles);
              }
              if(userDoc && userDoc.businessName){
                this.storage.set('bname',userDoc.businessName);
              }
              if(userDoc && userDoc.muncipality){
                this.storage.set('userMuncipality',userDoc.muncipality);
              }
              if(userDoc.language && userDoc.language != ''){
               this.events.publish('user:lan',userDoc.language, user.uid);
              }
          }
          else{

            await this.storage.set('uid', user.uid);

            console.log("usedoc");
            console.log(userDoc);
            if(userDoc && userDoc.email){
               await this.storage.set('email', userDoc.email);
            }

            if(userDoc && userDoc.name){
               await this.storage.set('uname', userDoc.name);
            }

            if(userDoc && userDoc.roles){
               await this.storage.set('roles', userDoc.roles);
            }
            if(userDoc && userDoc.muncipality){
              this.storage.set('userMuncipality',userDoc.muncipality);
            }
             if(userDoc.language && userDoc.language != ''){
               this.events.publish('user:lan',userDoc.language, user.uid);
              }

            
            this.events.publish('log:add','Logged In','Auth', null);


            
  	      	this.events.publish('user:authenticated');
            
          }

          }
          else{
            this.events.publish('user:notActive');
          }
	     }

	  });

     this.events.subscribe('auth:signInWithEmailAndPassword', (email, password) => {

      this.signInWithEmailAndPassword(email, password);

     });


     this.events.subscribe('auth:initiateResetPassword', (email) => {

       this.initiateResetPassword(email);

     });

     this.events.subscribe('auth:verifyResetPassOTP', (email, otp) => {

       this.verifyResetPassOTP(email,otp);

     });

      this.events.subscribe('auth:signupUser', (details) => {

       this.signupUser(details);

     });

      this.events.subscribe('auth:activateAccount', (email, password,code) => {

       this.checkActivationCode(email,password, code);

     });

     this.events.subscribe('auth:logout', () => {

      this.logout();

     });

      this.events.subscribe('auth:sendReactivationLink', (email) => {

       this.sendReactivationLink(email);

     });

  }


  setupRolesJobs(){

  }



  signInWithEmailAndPassword(email, password){

      
  	  this.fireAuth.auth.signInWithEmailAndPassword(email, password).then((userInfo) => {
    	 
        console.log("signed with email password", userInfo);

        // if(userInfo && userInfo.user && userInfo.user.uid){
        //   this.pushFCMToken(userInfo.user.uid);
        // }

        
        
    		

	   })
	   .catch((error: any) => {
          if(error){	
            	console.log("publishing auth failure");
            	console.log(error);
              this.events.publish('log:add',error.message,'Auth', {email:email});
      		    this.events.publish('auth:loginFailure');
          }
  	   }); 

      
  }

  async initiateResetPassword(email:string){


      await this.afs.collection('temp').doc('password').collection('reset').add({email:email,status:'initiated'});
      this.events.publish('auth:resetPasswordInitiated');
  }

  async verifyResetPassOTP(email:string, otp:string){

      this.http.post(CLOUD_FUNC_URL + 'verifyOtp',
                { email: email, otp:otp }).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('auth:resetOTPVerified');
                    }
                    else{
                       this.events.publish('auth:resetOTPFailed');
                    }

      });
       
  }

  async signupUser(details:any){

      this.http.post(CLOUD_FUNC_URL + 'activateSignupUser',
                details).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('auth:signupUserCompleted',res);
                    }
                    else{
                       this.events.publish('auth:signupUserFailed',res);
                    }

      });
       
  }

  async updatePassword(email:string, password:string){

     console.log("calling update password");

     this.http.post(CLOUD_FUNC_URL + 'updatePassword',
                { email: email, password:password }).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('auth:passwordUpdated');
                    }
                    else{
                       this.events.publish('auth:passwordUpdateFailed');
                    }

      });
  }

   async sendReactivationLink(email:string){

   

     this.http.post(CLOUD_FUNC_URL + 'resendActivationLink',
                { email: email}).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('auth:activationSuccess');
                    }
                    else{
                       this.events.publish('auth:activationFailure');
                    }

      });
  }


  async checkActivationCode(email:string, password:string, activationCode:number){

     console.log("calling update password");

    const userData:any = await this.afs.collection('users',ref => ref.where('email', '==', email)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();

    console.log(userData);
    console.log(activationCode);

    if(activationCode == userData[0].activationCode){

       this.events.publish('auth:activationCodeMatched');

       this.signInWithEmailAndPassword(email, password);
    }

    else{

       this.events.publish('auth:activationCodeFailed');
    }
    
  }


  // pushFCMToken(uid){

  //      this.fcm.getToken().then(token => {
       
  //                 this.data.addPushToken(uid, token);
                  
  //       });
        
       
  // }

  async logout(){
    this.events.publish('log:add','Logged Out','Auth', null);
    console.log("inside logout function");
    this.data.deletePushTokens();
    await this.fireAuth.auth.signOut();
    await this.storage.remove('email');
    await this.storage.remove('roles');
    await this.storage.remove('uid');
    this.events.publish('auth:logoutSuccess');
  }

  showLogoutButtonFn(value:any) {
    console.log('value in Service:', value);
    this.showLogoutBtnSubject.next(value)
  }




}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts